import { HTMLSelect } from "@blueprintjs/core";
import useMapViewConfiguration from "contexts/MapViewConfigurationContext/hooks/useMapViewConfiguration";
import { useMapViewRoutingMetadata } from "contexts/RoutingMetadataContext";
import { ColorMode } from "types/busFilterTypes";
import { RegionType } from "types/regionType";
import FilterWrapper from "./FilterWrapper";

const COLOR_MODE_OPTIONS: Array<{ value: ColorMode; label: string }> = [
    { value: ColorMode.CAPACITY, label: "Available capacity (MW)" },
    { value: ColorMode.CONSTRAINT_COUNT, label: "# of 0 MW constraints" }
];

const ColorModeFilter: React.FC = () => {
    const { region } = useMapViewRoutingMetadata();
    const {
        busFiltersConfiguration: {
            busFilters,
            updateColorMode,
            filtersDisabled
        }
    } = useMapViewConfiguration();

    // Only show for CAISO
    if (region !== RegionType.CAISO) {
        return null;
    }

    const currentColorMode = busFilters.colorMode ?? ColorMode.CAPACITY;

    return (
        <FilterWrapper label="Color by">
            <HTMLSelect
                value={currentColorMode}
                onChange={(e) =>
                    updateColorMode(e.currentTarget.value as ColorMode)
                }
                disabled={filtersDisabled}
                fill={true}
            >
                {COLOR_MODE_OPTIONS.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </HTMLSelect>
        </FilterWrapper>
    );
};

export default ColorModeFilter;
